<template>
  <div class="" id="Rights">
    <!-- <mt-header fixed title="权益说明">
        <router-link to="/" slot="left">
            <mt-button icon="back"></mt-button>
        </router-link>
    </mt-header> -->
    <!-- <div class="line-59"></div> -->
    <div class="img">
        <img src="static/image/explain.png" alt="">
    </div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Header,
  Cell,
  DatetimePicker
} from 'mint-ui';
import Vue from "vue";
Vue.component(Header.name,Header);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Cell.name, Cell);
Vue.component(DatetimePicker.name, DatetimePicker);
export default {
  name: 'Rights',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  loadMore() {
  this.loading = true;
  setTimeout(() => {
    let last = this.list[this.list.length - 1];
    for (let i = 1; i <= 10; i++) {
      this.list.push(last + i);
    }
    this.loading = false;
  }, 2500);
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a{
    color: #2c2c2c;
}
html{
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Rights.vue